<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<!-- <app-breadcrumb page-title="Study Information" /> -->
			</div>
		</div>
		<app-table :id="tableId" :options="options"/>

        <student-profile-wizard 
            v-if="isStudentProfileModalActive" 
            :row-data="rowData"
            :LeadId="LeadId"
            :selected-url="selectedUrl"
            :modal-id="formId" 
            :table-id="tableId" 
            @close-modal="closeStudenProfileModal" />
	</div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { StudentListWithCourseSchema } from "./StudentListWithCourseSchema";
import StudentProfileFornWizard from "./StudentProfileFornWizard";

export default {
	extends: CoreLibrary,
	name: "StudentListWithCourseTable",
    components: {
        'student-profile-wizard': StudentProfileFornWizard
    },
	props: {
		CourseId: {
			type: Number,
		},
	},
	data() {
		return {
            LeadId : '',
        }
    },
	mixins: [StudentListWithCourseSchema],
	created() {
		this.options.columns = [...this.tableColumns];
	},
	mounted() {
		window.handleProfileStudent = (id) => {
            this.leadId = id;
			this.openProfileStudent(id);
		};
    },
	methods: {
		openProfileStudent(id){
            this.selectedUrl = `transaction/get-detail-profile-student?lead_id=${id}&course_id=${this.CourseId}`;
            this.openProfileStudentModal();
		},
		openProfileStudentModal(){
            this.isStudentProfileModalActive = true;
		},
		openDeleteModal() {
		},

        closeStudenProfileModal() {
            let m_id = `#student-profile-form`;
            $(m_id).modal('hide');
            this.isStudentProfileModalActive = false;
			this.reSetData();
        },
		confirmed() {
		},
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
</script>
